import request from '@/utils/request'

// 登录
export function loginByUsername(data) {
  return request({
    url: '/user/mobilelogin',
    method: 'post',
    data
  })
}

// 获取验证手机验证码
export function loginByCode(data) {
  return request({
    url: '/sms/send',
    method: 'post',
    data
  })
}

// 推出登录
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

// 用户信息
export function getUserInfo(data) {
  return request({
    url: '/api/user/navlist',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js